import { List } from '../List'

export class CouncilNameParent extends List {
  constructor(obj) {
    super(CouncilName, obj)
  }
}

export class CouncilName {
  constructor(obj) {
    this.id = obj?.id || null
    this.name = obj?.name || null
    this.speciality = obj?.speciality || null
  }

  getForAPI() {
    return {
      id: this.id,
      name: this.name,
      speciality: this.speciality
    }
  }

  static buildFromAPI(obj) {
    const _this = new CouncilName()
    if (obj) {
      _this.id = obj.id || null
      _this.name = obj.name || null
      _this.speciality = obj.speciality || null
    }
    return _this
  }
}
